import styled from 'styled-components';
import React, { useState } from 'react';

import StyledContainer from '@design-system/styled/Container';
import { BANNER_IMGS } from '@source/pages/CarroCertified/constants';
import { IRegionProps } from '@source/interface';
import i18n from '@source/i18next';
import CCPOCertified from './CCPOCertified';
import CCPOHeading from './CCPOHeading';

export const StyledCCPOContainer = styled.div<{ images: Record<number, string>; minHeight?: number }>`
  background-image: url(${(props) => props.images[375]});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: ${(props) => (props.minHeight ? `${props.minHeight}px` : '408px')};
  position: relative;

  @media (min-width: 576px) {
    background-image: url(${(props) => props.images[576]});
    min-height: 422px;
  }

  @media (min-width: 768px) {
    background-image: url(${(props) => props.images[768]});
  }

  @media (min-width: 992px) {
    background-image: url(${(props) => props.images[992]});
    min-height: 480px;
  }

  @media (min-width: 1280px) {
    background-image: url(${(props) => props.images[1280]});
    min-height: 686px;
  }

  @media (min-width: 1920px) {
    background-image: url(${(props) => props.images[1920]});
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const transformImages = Object.fromEntries(
  Object.entries(BANNER_IMGS).map(([key, url]) => [
    key,
    url.replace('https://cdn.carro.co/', 'https://cdn.carro.co/tr:n-carro_certified_page_main_background_image/'),
  ]),
);

const CCPOPageBanner = ({ region }: IRegionProps) => {
  const isBM = i18n.language === 'ms';
  const isJA = i18n.language === 'ja';
  const isChinese = region === 'hk' && i18n.language !== 'en';
  const isHkEn = region === 'hk' && i18n.language === 'en';
  let customBannerMinHeight = 408;

  const [open, setOpen] = useState<boolean>(false);

  if (region === 'my' && isBM) {
    customBannerMinHeight = 425;
  }

  return (
    <StyledCCPOContainer images={transformImages} minHeight={customBannerMinHeight}>
      <StyledContainer isChinese={isChinese} isHkEn={isHkEn} open={open}>
        <StyledWrapper>
          <CCPOHeading region={region} />
          <CCPOCertified region={region} open={open} setOpen={setOpen} />
        </StyledWrapper>
      </StyledContainer>
    </StyledCCPOContainer>
  );
};

export default CCPOPageBanner;
